import axios from "axios";
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../utils/AuthContext';
import { removeProduct } from '../api/newprod'; 
import { useParams } from "react-router-dom";
import { fetchSellerBids, placeBid, deleteBid } from '../api/commerce';
import { Info } from 'lucide-react';
import { CONFIG } from "../config";
import { SidebarProvider } from "../components/SidebarContext";
import InfoMark from '../components/InfoMark';
import ProductCardModal from '../components/ProductCardModal';
import Loading from '../components/loading/Loading';
import Sidebar from '../components/Sidebar';
import SidebarToggle from '../components/SidebarToggle';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import ProductForm from '../components/ProductForm';
import ProductUpdateForm from '../components/ProductUpdateForm';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/CreateForm.css";


const ProductList = () => {
  const navigate = useNavigate();
  const [consoleError, setConsoleError] = useState("");
  const [products, setProducts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newprodModal, setnewprodModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModal, setInfoModal] = useState(false);
  const [InfoP, setInfoP] = useState(null);
  const [setlang, setLang] = useState("fa")
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { lang } = useParams();
  const { user, loading, isAuthenticated } = useAuth();
  const currentUser = user;
  const location = useLocation();
  const pageSize = 10; 
  const API_BASE = CONFIG.API_URL

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location]);

  useEffect(() => {
    fetch("/data/InfoNote.json")
      .then((res) => res.json())
      .then((data) => setInfoP(data.ProductManagement))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);

  const loadProducts = useCallback(async () => {
    try {
      let allResults = [];
      let url = `${API_BASE}/api/productlist/?page_size=500`; 
      while (url) {
        const response = await axios.get(url, { withCredentials: true });
        const data = response.data;
        if (Array.isArray(data.results)) {
          allResults = [...allResults, ...data.results];
        }
        url = data.next;
      }
  
      // filter by owner
      const filtered = allResults.filter((p) => p.owner_id === user?.id && p.status !== "removed");

      // handle pagination client-side
      const totalPages = Math.ceil(filtered.length / pageSize);
      const startIndex = (page - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginated = filtered.slice(startIndex, endIndex);
  
      setProducts(paginated);
      setTotalPages(totalPages);
      
    } catch (error) {
      setConsoleError("Error loading products:", error);
      setProducts([]);
      setTotalPages(1);
    }
  }, [user?.id, page, pageSize]);
  
  useEffect(() => {
    if (!loading && user) {
      loadProducts();
    }
  }, [loading, user, loadProducts]);

  const handleDelete = async (productId) => {
    if (!window.confirm(setlang === "en" ? "Are you sure you want to remove this product?" : "آیا می خواهید این آگهی را برای همیشه حذف کنید؟")) return;
    try {
      await removeProduct(productId); 
      loadProducts();
    } catch (error) {
      setConsoleError("Error deleting product:", error);
      alert(setlang==="en"?"Failed to delete product.":"مشکلی رخ داد، لطفا دوباره تلاش کن");
    }
  };

  const handleEdit = (product) => {
    setEditing(product);
    setShowModal(true);
  };

  const handleNewprod = () => {
    setnewprodModal(true);
  };

  
  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);

  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');
  
  // Utilities
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target !== e.currentTarget) {
      closeModal();
    }
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  
  if (loading) return <Loading />;  
  return (
  <>
    <NavbarLog />
    <SidebarProvider side={setlang}>
    <SidebarToggle />
    <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
    {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}
     
   <div className="items-page-with-sidebar">
      {setlang==="en" && 
          <Sidebar />
        }
    <div className="PFProd-page">
        {loading ? (
          <p>{setlang==="en"?"Loading...":"در حال بارگذاری..."}</p>
        ) : (
        <>
        {Array.isArray(products) && products.length > 0 ? (
          <div className="PFproduct-list">
            {setlang === "en" ? 
              <h1>Your Current Listing</h1>
              :
              <h1>مدیریت آگهی‌ها</h1>
            }

            {!newprodModal? 
            <button className="listingbtn" onClick={() => handleNewprod()}
            style={{flex:"1 1 auto", right:"0"}}>{setlang === "en" ? "+ New Listing" : "آگهی جدید" } </button> 
            :null}
              
            {/* Modal for product create */}
            {newprodModal && ( 
                <ProductForm
                  product={editing}
                  onSave={() => {
                    setEditing(null);
                    loadProducts();
                    setnewprodModal(false);
                  }}
                  onCancel={() => {   
                    setnewprodModal(false); 
                  }}
                />
            )}

            {products.map((product, productId) => (
              <>
              <div key={productId} className="PFproduct-card">
                <div className="PFproduct-info">
                  <h2>{product.name}</h2>
                  
                  {product.description && (
                    setlang === "en" ? (
                      <div className="info-row">
                        <div><span className="info-label">Description: </span></div>
                        <p className="modal-description"> {product.description || "No description available."}</p>
                      </div>
                    ):(
                      <div className= "info-row-fa">
                        <div><p className="modal-description"> {product.description || "توضیحی وجود ندارد."}</p></div>
                        <div><span className="info-label"> :توضیحات</span></div>
                      </div>
                    )
                  )}
                  {setlang === "en" ? 
                  <div className="info-row">
                    <span className="info-label">Asking Price: </span>
                    <span className="modal-price">IRT { new Number(product.price).toLocaleString()}</span>
                  </div> :
                  <div className="info-row-fa">
                    <span className="modal-price-fa">تومان</span>
                    <span className="modal-price-fa">{toPersiDigits(new Number(product.price).toLocaleString())}</span>
                    <span className="info-label"> :قیمت درخواستی</span>
                  </div>
                  }
                  {product.category && (
                  setlang === "en" ? (
                  <div className="info-row">
                    <span className="info-label">Category: </span>
                    <div><span className="modal-author">{product.category}</span></div>
                  </div>
                  ):(
                  <div className="info-row-fa">
                    <div><span className="modal-author">{product.category}</span></div>
                    <span className="info-label"> :دسته‌بندی</span>
                  </div>
                  ))}
                  {product.style && (
                  setlang === "en" ? (
                  <div className="info-row">
                    <span className="info-label">Style: </span>
                    <div><span className="modal-author"> {product.style}</span></div>
                  </div>
                  ):(
                  <div className="info-row-fa">
                    <div><span className="modal-author"> {product.style}</span></div>
                    <span className="info-label"> :استایل</span>
                  </div>
                  ))}
                  {product.material && (
                  setlang === "en" ? (
                    <div className= "info-row" >
                      <span className="info-label">Material: </span>
                      <div><span className="modal-author">{product.material}</span></div>
                    </div>
                  ):(
                    <div className= "info-row-fa">
                      <div><span className="modal-author">{product.material}</span></div>
                      <span className="info-label"> :جنس ساخت</span>
                    </div>
                  ))}
                  {setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">{product.length ? "Dimensions: ": product.width ? "Dimensions: ": product.height ? "Dimensions: ":null}</span>
                      <div><span className="modal-author">{ product.length ? "L " + new Number(product.length).toLocaleString() + " cm x " : " " }{ product.width ? "W " + new Number(product.width).toLocaleString() + " cm x " : " " }{ product.height ? "H " + new Number(product.height).toLocaleString() + " cm" : " " }</span></div>
                    </div>
                  ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author">{ product.length ? toPersiDigits(new Number(product.length).toLocaleString()) + " طول x " : null }{ product.width ? toPersiDigits(new Number(product.width).toLocaleString()) + " عرض x " : null }{ product.height ?  toPersiDigits(new Number(product.height).toLocaleString()) + " ارتفاع" : null }</span></div>
                      <span className="info-label">{product.length ? " :(سانتیمتر)ابعاد": product.width ? " :(سانتیمتر)ابعاد": product.height ? " :(سانتیمتر)ابعاد":null}</span>
                    </div>
                  )}
                  {product.weight && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Weight: </span>
                      <div><span className="modal-author">{(new Number(product.weight).toLocaleString())} kg</span></div>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author">{toPersiDigits(new Number((product.weight)).toLocaleString())} kg</span></div>
                      <span className="info-label"> :وزن</span>
                    </div>
                  ))}
                  {product.feature_one && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Special Features: </span>
                      <div><span className="modal-author">{product.feature_one}</span></div>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author">{product.feature_one}</span></div>
                      <span className="info-label"> :ویژگی‌های خاص</span>
                    </div>
                  ))}
                  {product.feature_two && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Basic Features: </span>
                      <div><span className="modal-author">{product.feature_two}</span></div>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author">{product.feature_two}</span></div>
                      <span className="info-label"> :ویژگی‌های دیگر</span>
                    </div>
                  ))}
                  {product.artist && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">By: </span>
                      <span className="modal-author"> {product.artist}</span>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <span className="modal-author"> {product.artist}</span>
                      <span className="info-label"> :اثر</span>
                    </div>
                    )
                  )}
                  {product.owner && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Owner: </span>
                      <span className="modal-author"> {product.owner}</span>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <span className="modal-author"> {product.owner}</span>
                      <span className="info-label"> :فروشنده</span>
                    </div>
                    )
                  )}
                  {setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Is Biddable? </span>
                      <span> {product.is_biddable ? (setlang === "en" ? "Yes":"بله") : (setlang === "en" ? "No":"خیر")}</span>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <span> {product.is_biddable ? (setlang === "en" ? "Yes":"بله") : (setlang === "en" ? "No":"خیر")}</span>
                      <span className="info-label"> قابل مزایده؟</span>
                    </div>
                    )
                  }
                  {product.bidding_deadline && product.is_biddable && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Bidding Deadline: </span>
                      <span className="modal-author"> {dayjs.utc(product.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</span>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <span className="modal-author"> {toPersiDigits(dayjs.utc(product.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</span>
                      <span className="info-label"> :مهلت شرکت در مزایده تا</span>
                    </div>
                    )
                  )}
                  {product.status && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Status: </span>
                      <span className="modal-author"> {product.status === "TBR" ? "being verified": 
                                                        (product.status === "open" ? "Open": 
                                                        (product.status === "closed" ? "Inactive": 
                                                        (product.status === "removed" ? "Removed": 
                                                        (product.status === "timedout" ? "Timed Out": "Sold"))))}</span>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <span className="modal-author"> {product.status === "TBR" ? "در حال بررسی" : 
                                                        (product.status === "open" ? "فعال" : 
                                                        (product.status === "closed" ? "غیر فعال" : 
                                                        (product.status === "timedout" ? "پایان مزایده" : 
                                                        (product.status === "removed" ? "حذف شده": "فروخته شده"))))}</span>
                      <span className="info-label"> :وضعیت آگهی</span>
                    </div>
                    )
                  )}
                  {product.delivered_by && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Delivery Mode: </span>
                      <div><span className="modal-author">{product.delivered_by}</span></div>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author">{product.delivered_by}</span></div>
                      <span className="info-label"> :روش ارسال محصول</span>
                    </div>
                  ))}
                
                  {product.pickup_address && (
                    setlang === "en" ? (
                    <div className="info-row">
                      <span className="info-label">Delivery Details: </span>
                      <div><span className="modal-author"> {product.pickup_address}</span></div>
                    </div>
                    ):(
                    <div className="info-row-fa">
                      <div><span className="modal-author"> {product.pickup_address}</span></div>
                      <span className="info-label"> :روش ارسال محصول به مشتری</span>
                    </div>
                  ))}

                  {setlang === "en" ? (
                    <div className="info-row"  style={{marginTop:"10px", gap:"0"}}>
                      <span className="info-label"><small>Added on: </small></span>
                      <span className="modal-date"><small>{dayjs.utc(product.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</small></span>
                    </div>
                  ):(
                    <div className="info-row-fa" style={{marginTop:"10px", gap:"0"}}>
                     <span className="modal-date"><small>{toPersiDigits(dayjs.utc(product.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</small></span>
                      <span className="info-label"><small> :تاریخ آگهی</small></span>
                    </div>
                  )}
                  {setlang === "en" ? (
                    <div className="info-row" >
                      <span className="info-label"><small>Last update on: </small></span>
                      <span className="modal-date"> <small>{dayjs.utc(product.updated_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</small></span>
                    </div>
                  ):(
                    <div className="info-row-fa">
                     <span className="modal-date"><small>{toPersiDigits(dayjs.utc(product.updated_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</small></span>
                      <span className="info-label"><small> :آخرین به‌روزرسانی</small></span>
                    </div>
                  )}
                </div> 

                <div className="PFproduct-images">
                    {/* Images */}
                    {Array.isArray(product.images) && product.images.length > 0 &&
                      product.images.map((img) => (
                        <img
                          key={img.id}
                          src={img.image}
                          alt={product.name}
                          className="PFproduct-image"
                        />
                      ))
                    }

                    {/* Videos */}
                    {Array.isArray(product.videos) && product.videos.length > 0 &&
                      product.videos.map((vid) => (
                        <video
                          key={vid.id}
                          src={vid.video}
                          controls
                          className="PFproduct-image"
                        />
                      ))
                    }

                    {/* Fallback if no media */}
                    {(!product.images?.length && !product.videos?.length) && (
                      <p className="PFno-media">{setlang === "en" ? "No images available" : "عکسی وجود ندارد" }</p>
                    )}
                </div>
              </div>

              {/* Update & Delete buttons */}
              <div>
                {product.status === "open" || product.status === "TBR" ?(
                <div className="PFproduct-actions"> 
                  <button className='btn-remove' onClick={() => handleDelete(product.id)}>{setlang === "en" ? "Remove" : "حذف آگهی" }</button> 
                  <button className='btn' onClick={() => handleEdit(product)}>{setlang === "en" ? "Update": "به روزرسانی" }</button> 
                  <button className='btn' onClick={()=>setIsModalOpen(product.id)}>{setlang === "en" ? "View Article": "نمایش آگهی" }</button> 
                </div>
                ):(
                <div className="PFproduct-actions"> 
                  <button className='btn-remove' onClick={() => handleDelete(product.id)}>{setlang === "en" ? "Remove" : "حذف آگهی" }</button> 
                </div>
                )}
              </div>

              {isModalOpen === product.id && 
                <div onClick={handleOverlayClick} key={product.id}>
                  <ProductCardModal 
                  isModalOpen={isModalOpen}
                  productId={product.id}
                  ownerId={product.owner_id}
                  ownerUsername={product.owner}
                  images={product.images}
                  videos={product.videos}
                  name={product.name}
                  description={product.description}
                  artist={product.artist}
                  style={product.style}
                  category={product.category}
                  material={product.material}
                  feature_one={product.feature_one}
                  feature_two={product.feature_two}
                  length={product.length}
                  width={product.width}
                  height={product.height}
                  weight={product.weight}
                  date={product.created_at}
                  date_pa={dayjs.utc(product.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}
                  price={product.price}
                  bidzone_stored={product.bidzone_stored}
                  isAuthenticated={isAuthenticated}
                  is_biddable={product.is_biddable}
                  b_deadline={product.bidding_deadline}
                  b_deadline_pa={dayjs.utc(product.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}
                  user={user}
                  delivered_by={product.delivered_by}
                  pickup_address={product.pickup_address}
                  setlang={setlang}
                  currentUser={currentUser}
                  />
                </div>
                }
              </>
            ))}
          </div>
          ) : (
            <>
              <div className="PFproduct-list">
                {setlang === "en" ? 
                  <h1>Your Current Listing</h1>
                  :
                  <h1>مدیریت آگهی‌ها</h1>
                }

                {!newprodModal && 
                <div > 
                  <button className='listingbtn' style={{ position:'relative', width: '300px', padding:'0.7rem', marginTop: '30px'}} onClick={() => handleNewprod()}>{setlang === "en" ? "+ New Listing" : "آگهی جدید" }</button>
                </div> 
                } 
                
                {/* Modal for product create */}
                {newprodModal && ( 
                  <div className=""> 
                    <ProductForm
                      product={editing}
                      onSave={() => {
                        setEditing(null);
                        loadProducts();
                        setnewprodModal(false);
                      }}
                      onCancel={() => {   
                        setnewprodModal(false); 
                      }}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </>
        )}

        {/* Pagination controls */}
        <div className='pagination-controls'>
          <button
            disabled={page <= 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            {setlang === "en" ? "Previous" : " قبلی" }
          </button>
          {setlang === "en" ? 
          <span>Page {page} of {totalPages>0?totalPages:1}</span>:
          <span>صفحه {page} از {totalPages>0?totalPages:1}</span>
          }
          <button
            disabled={page >= totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            {setlang === "en" ? "Next" : "بعدی" }
          </button>
        </div>

      {/* Modal for product update */}
      {showModal && ( 
        <div className="modal-overlay"> 
          <div className="modal-content"> 
            <ProductUpdateForm
              product={editing}  
              onSave={() => {    
                setEditing(null); 
                setShowModal(false);
                loadProducts();  
              }}
              onCancel={() => {   
                setEditing(null); 
                setShowModal(false); 
              }}
            /> 
          </div> 
        </div> 
      )} 
    </div>

    {setlang==="fa" && 
      <Sidebar />
    }
     </div>
    </SidebarProvider>
    <Footer />
  </>
);
};

export default ProductList;
